import aliyuOss from './aliyun-oss';
import tencentCos from './tencent-cos';
import contentCloudTypeEnum from '@/common/enums/contentCloudTypeEnum';

async function uploadFiles(files, onProgress, onFinish) {
  switch (process.env.VUE_APP_OSS_TYPE) {
    case contentCloudTypeEnum.ALIYUN_OSS:
      return aliyuOss.uploadFiles(files);

    case contentCloudTypeEnum.TENCENT_COS:
      return tencentCos.uploadFiles(files, onProgress, onFinish);
    default:
      console.log(process.env.VUE_APP_OSS_TYPE);
      throw new Error('请选择正确的云存储');
  }
}

export default {
  uploadFiles,
};
